/* import __COLOCATED_TEMPLATE__ from './class-group-jns-roger-weston-points-card.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class RogerWestonPointsCardComponent extends Component 
{
	@service store;
	@service csv;
	
	@tracked classGroup = null;
	@tracked className = null;
	
	@tracked selectedRacePts = null;//pts destination
	@tracked selectedRacePtsName = null;
	
	@tracked selectedEntryText = null;//school data
	@tracked selectedEntryTextName = null;
	
	@action
	async selectClassGroup(event)
	{
		var classGroupId = event.target.value;
		
		if(classGroupId == '-')
		{
			this.classGroup = null;
		}
		else
		{
			this.classGroup = await this.store.findRecord('classGroup', classGroupId);
			let results = (await this.classGroup.get('results')).slice();
			for(const result of results)
			{
				result.calculatedRacePoints = null;
			}
			this.calculateRacePoints();
		}
	}
	
	@action
	async selectClass(event)
	{
		if(event.target.value == '-')
		{
			this.className = null;
		}
		else
		{
			this.className = event.target.value;
			this.calculateRacePoints();
		}
	}
	
	@action
	selectRacePts(event)
	{
		var ptsCol = event.target.value;
		
		if(ptsCol == '-')
		{
			this.selectedRacePts = null;
			this.selectedRacePtsName = null;
		}
		else
		{
			this.selectedRacePts = ptsCol;
			this.selectedRacePtsName = ptsCol+"Name";
		}
		this.calculateRacePoints();
	}
	
	@action
	selectEntryText(event)
	{
		var ptsCol = event.target.value;
		
		if(ptsCol == '-')
		{
			this.selectedEntryText = null;
			this.selectedEntryTextName = null;
		}
		else
		{
			this.selectedEntryText = ptsCol;
			this.selectedEntryTextName = ptsCol+"Name";
		}
		this.calculateRacePoints();
	}
	
	@action
	async savePoints()
	{	
		if(this.classGroup && this.selectedRacePts != null && this.className != null && this.selectedEntryText != null)
		{
			var results = await this.classGroup.get('results');
			await this.args.event.hasMany('entries').reload();
			var entries = (await this.args.event.get('entries')).slice();
			for(var result of [...results])
			{
				for(var entry of entries)
				{
					if(entry.bib == result.bib && result.className == this.className)
					{
						entry.set(this.selectedRacePts,result.calculatedRacePoints);
						await entry.save();
					}
				}
			}
		}
	}
	
	async calculateRacePoints()
	{
		if(this.classGroup && this.selectedRacePts != null && this.className != null && this.selectedEntryText != null)
		{
			let results = (await this.classGroup.get('results')).slice();
			results = results.filter((result) =>
			{
				return result.get(this.selectedEntryText) != null;
			});
			results = results.filter((result) =>
			{
				return result.className == this.className;
			});
			
			//sort by region
			results.sort(this.teamSort);
			//collect all the teams
			const teamNames = [];
			for(const result of results)
			{
				if(!teamNames.includes(result.get(this.selectedEntryText)))
				{
					teamNames.push(result.get(this.selectedEntryText));
				}
			}
			const teams = [];
			for(const team of teamNames)
			{
				teams.push({name:team,count:0});
			}
			results.sort(this.placeSort);
			//mark results as validforpoints
			for(const result of results)
			{
				result.validForPoints = false;
				for(const team of teams)
				{
					if(team.name == result.get(this.selectedEntryText))
					{
						if(result.status == "OK")
						{
							result.validForPoints = true;
							team.count++;
						}
					}
				}
			}
			//sort by time
			results.sort(this.placeSort)
			//assign points
			let currentPoints = 100;
			let tiePoints = 100;
			for(const result of results)
			{
				if(result.validForPoints)
				{
					if(result.isTie)
					{
						result.calculatedRacePoints = tiePoints;
						currentPoints--;
					}
					else
					{
						result.calculatedRacePoints = currentPoints;
						currentPoints--;
						tiePoints = currentPoints;
					}
				}
			}
		}
	}
	
	teamSort(a,b)
	{
		const aClub = a.text1 || "";
		const bClub = b.text1 || "";
		return aClub.localeCompare(bClub);
	}
	placeSort(a,b)
	{
		return a.place-b.place;
	}
}